export default __webpack_public_path__ + "static/media/Refresh.05f2499d.svg";